var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowDown32Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#0061ED",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9991 23.6006C15.5214 23.6006 15.0435 23.4182 14.6791 23.0541L3.21306 11.5878C2.48367 10.8584 2.48367 9.67581 3.21306 8.94672C3.94215 8.21762 5.1245 8.21762 5.85395 8.94672L15.9991 19.0926L26.1447 8.94742C26.8738 8.21833 28.0563 8.21833 28.7853 8.94742C29.5151 9.67652 29.5151 10.8587 28.7853 11.5881L17.3194 23.0546C16.9549 23.4185 16.477 23.6006 15.9991 23.6006Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown32Px);
export default ForwardRef;